import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCardIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
function Footer() {
  const links = [{
    label: 'Inicio',
    href: '/',
    isExternal: false
  }, {
    label: 'Cómo funciona',
    href: '/#como-funciona',
    isExternal: true
  }, {
    label: 'Simulador',
    href: '/#simulador',
    isExternal: true
  }, {
    label: 'Términos',
    href: '/terminos',
    isExternal: false
  }, {
    label: 'Privacidad',
    href: '/privacidad',
    isExternal: false
  }, {
    label: 'Contacto',
    href: 'mailto:hola@creditual.com',
    isExternal: true
  }];
  return <footer className="bg-[#E8EDF5] py-6 md:py-8 border-t border-gray-200" data-id="element-29">
      <div className="container mx-auto max-w-7xl px-4" data-id="element-30">
        {/* Contenido principal */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 mb-4" data-id="element-31">
          {/* Logo */}
          <div className="flex items-center" data-id="element-32">
            <CreditCardIcon className="h-5 w-5 text-[#2B5FD9] mr-1.5" data-id="element-33" />
            <span className="text-base font-bold text-[#0A1628]" data-id="element-34">
              Creditual
            </span>
          </div>

          {/* Links de navegación */}
          <nav className="flex-1" data-id="element-35">
            <ul className="flex flex-wrap justify-center gap-x-4 gap-y-1" data-id="element-36">
              {links.map((link, i) => <li key={i} data-id="element-37">
                  {link.isExternal ? <a href={link.href} className="text-xs text-[#6B7280] hover:text-[#0A1628] transition-colors" data-id="element-38">
                      {link.label}
                    </a> : <Link to={link.href} className="text-xs text-[#6B7280] hover:text-[#0A1628] transition-colors" data-id="element-39">
                      {link.label}
                    </Link>}
                </li>)}
            </ul>
          </nav>

          {/* Redes sociales */}
          <div className="flex items-center gap-3" data-id="element-40">
            <a href="https://linkedin.com/company/creditual" target="_blank" rel="noopener noreferrer" className="text-[#6B7280] hover:text-[#0A1628] transition-colors" aria-label="LinkedIn" data-id="element-41">
              <LinkedinIcon className="h-4 w-4" data-id="element-42" />
            </a>
            <a href="https://www.instagram.com/creditual" target="_blank" rel="noopener noreferrer" className="text-[#6B7280] hover:text-[#0A1628] transition-colors" aria-label="Instagram" data-id="element-43">
              <InstagramIcon className="h-4 w-4" data-id="element-44" />
            </a>
          </div>
        </div>

        {/* Copyright y disclaimer */}
        <div className="text-center space-y-1" data-id="element-45">
          <p className="text-[10px] text-[#6B7280]" data-id="element-46">
            © 2025 Creditual — Monetización inmobiliaria inteligente.
          </p>
          <p className="text-[9px] text-[#6B7280] max-w-3xl mx-auto" data-id="element-47">
            Creditual SpA actúa como estructurador financiero. Las operaciones
            están respaldadas por activos inmobiliarios y sujetas a evaluación
            individual.
          </p>
        </div>
      </div>
    </footer>;
}
export default Footer;
export { Footer };